export const validEmail = (text: string) => {
    const pref = "azure_";
    if (text.startsWith(pref)) {
        return text.slice(pref.length);
    }
    return text;
}